import React from 'react';
import { Link } from 'react-router-dom';
import { usePartecipante } from '../reducers';
import { displayBadgePermesso, displayUser } from '../utils';
import './ElencoPresenze.scss';

interface Props {
  participants: number[];
  currentParticipantId: number;
}

const ElencoPresenze = (props: Props) => {
  const people = usePartecipante(props);
  return <ul className="presence-people-list">
    {props.participants.map(id => {
      const person = people.find(person => person.id === id);
      const name = person ? displayUser(person.user) || person.user.username : `Partecipante #${id}`;
      return <li key={id}>
        <Link to={`/utente/${id}/`} className="presence-person">
          {person?.avatar && <img src={`/avatars/${person.avatar}/`} alt="" />}
          <span>{name}</span>
          {person && displayBadgePermesso(person.permessi)}
          {id === props.currentParticipantId && <small className="text-muted">(tu)</small>}
        </Link>
      </li>;
    })}
  </ul>;
};

export default ElencoPresenze;
